import cvPath from '../assets/files/Resume-Pawnpunnarai-Sai-Senior-Developer.docx.pdf';
import coverLetterPath from '../assets/files/Cover-Letter-(General-Version-for-Senior-Developer).pdf';

const contact = {
  linkedin: 'https://www.linkedin.com/in/pawnpunnarai-saimoonkham-b0041b130/',
  email: 'pawnpunnarai.saimoonkham@gmail.com',
  phone: '0824960172',
  phoneDisplay: '082-496-0172',
  cvPath,
  coverLetterPath,
};

export default contact;
